// extracted by mini-css-extract-plugin
export var acenter = "eJMF";
export var aend = "_1ssv";
export var astart = "Fpsz";
export var root = "O-aX";
export var rootReversed = "SR56";
export var vbottom = "joYh";
export var vmiddle = "tKK+";
export var vtop = "GvCZ";